/**
 * Privacy Policy / Terms of Service links (the YouTube API audit and the Google OAuth branding require them to be reachable).
 * /privacy and /terms are SERVER-rendered pages, not SPA routes: plain <a> (never the router's Link) so the click is a full
 * document navigation, and the service worker's navigations are network-first, so the server answers them.
 */
export const APP_DESCRIPTION = "ContentOps Studio: an internal tool to publish and manage our own YouTube channels. Uses YouTube API Services.";

export function LegalLinks({ className = "", describe = false }: { className?: string; describe?: boolean }) {
  return (
    <footer className={`legal ${className}`}>
      {describe && <p className="legal-desc">{APP_DESCRIPTION}</p>}
      {describe && (
        // Official "Developed with YouTube" logo (YouTube API branding guidelines): small, never the most prominent element, links to YouTube.
        <a className="yt-badge" href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="Developed with YouTube">
          <picture>
            <source srcSet="/brand/developed-with-youtube-light.png?v=2" media="(prefers-color-scheme: dark)" />
            <img src="/brand/developed-with-youtube-dark.png?v=2" alt="Developed with YouTube" height={32} width={223} />
          </picture>
        </a>
      )}
      <nav aria-label="Legal" className="legal-links">
        <a href="/privacy">Privacy Policy</a>
        <span aria-hidden>·</span>
        <a href="/terms">Terms of Service</a>
      </nav>
    </footer>
  );
}
